import React, { Fragment } from 'react'
import { Form, Input, Typography } from 'antd'
import PropTypes from 'prop-types'

const inlineLayout = {
  labelCol: { xs: { span: 24 }, lg: { span: 8 } },
  wrapperCol: { xs: { span: 24 }, lg: { span: 12 } },
}

const tibiaLabel = (
  <Typography.Text style={{ fontSize: '18px' }}>
    <span style={{ color: '#d60202' }}>*</span>4. Informe o personagem no Tibia
    para receber os créditos
  </Typography.Text>
)

export const Tibia = ({ handleChange, answers }) => {
  return (
    <Fragment>
      <Form.Item name='tibiaId' label={tibiaLabel} {...inlineLayout}>
        <Input
          type='text'
          name='tibiaId'
          value={answers?.tibiaId}
          onChange={handleChange('tibiaId')}
          required
        />
      </Form.Item>
    </Fragment>
  )
}

Tibia.propTypes = {
  handleChange: PropTypes.func,
  answers: PropTypes.any,
}
